export function accumulateStudySeconds(
  accumulated: number,
  startedAt: number | undefined,
  now = Date.now(),
): number {
  const active = startedAt ? Math.max(0, Math.round((now - startedAt) / 1000)) : 0;
  return Math.max(0, accumulated) + active;
}
